<template>
  <div class="production" :class="themeClass">
    <div class="banner">
      <img
        width="100%"
        :src="headerBannerSrc"
        alt=""
      >
    </div>
    <div class="content">
      <div v-if="banner.length > 0" class="content-recommend">
        <p class="content-tit">推荐专区</p>

        <div class="swiper-box">
          <div class="swiper-content">
            <swiper
              ref="mySwiper"
              :options="swiperOptions"
            >
              <swiper-slide v-for="(item, index) in banner" :key="index">
                <a :href="item.href"><img width="100%" :src="item.image"></a>
              </swiper-slide>
              <div slot="pagination" class="swiper-pagination" />
            </swiper>

            <div
              slot="button-prev"
              class="swiper-button-prev"
              @click="handleClickSwiperButton(true)"
            />
            <div
              slot="button-next"
              class="swiper-button-next"
              @click="handleClickSwiperButton(false)"
            />
          </div>
        </div>
      </div>

      <div
        v-for="(production, index) in productions"
        :key="index"
        class="content-item"
      >
        <p class="content-tit">{{ production.title }}</p>
        <div class="production-list flex">
          <!-- <swiper ref="productionList">
            <swiper-slide
              v-for="(slide, idx) in production.experiences"
              :key="idx"
              class="production-slide"
            > -->
          <div
            v-for="(item, i) in production.experiences"
            :key="i"
            class="production-item"
            :xs="12"
            :sm="8"
          >
            <img
              :src="item.avatar"
              @click="handleProduction(item)"
            >
            <div class="production-info" @click="handleProduction(item)">
              <p class="production-tit">{{ item.name }}</p>
              <p class="production-subTit">团队: {{ item.developer.Name }}</p>
              <p class="production-desc">{{ item.instruction }}</p>
            </div>
          </div>
          <!-- </swiper-slide>
          </swiper> -->
        </div>
      </div>

      <!-- 更多 -->
      <!-- <div class="list-more">
        展示更多<br>
        <Icon type="ios-arrow-down" />
      </div> -->
    </div>
  </div>
</template>

<script>
import { os } from '@/utils/index'
import themeMix from '@/minixs/common'

const { isPc } = os()
const assetBasicCatalog = isPc ? 'pc' : 'mobile'
const basicSrc = `assets/images/procution/${assetBasicCatalog}`

export default {
  name: 'production-list',
  // 引入的组件
  components: {},
  // 混入
  mixins: [themeMix],
  // 当前页面的数据定义
  data() {
    return {
      notNextTick: true,
      activeIndex: 0,
      swiperOptions: {
        notNextTick: true,
        // autoplay: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        delay: 1000,
        loop: true
      },
      headerBannerSrc: require(`@/${basicSrc}/head-banner.jpeg`),
      banner: [],
      productions: []
    }
  },
  // 计算属性
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  watch: {
    $route(newVal) {
      if (newVal.meta.index !== 0) {
        this.swiper.autoplay.stop()
      } else {
        this.swiper.autoplay.start()
      }
    }
  },
  // 页面初始化的时候执行的方法
  created() {},
  // html已经渲染并挂载后的执行方法
  mounted() {
    this.getBanners()
    this.getProductLists()
  },
  // 当前页面的方法集合
  methods: {
    handleProduction(item) {
      this.$router.push({
        path: `/experiences/${item.id}`
      })
    },
    async getProductLists() {
      this.$Loading.start()
      const { data } = await this.$api.getProducts()
      this.$Loading.finish()

      this.productions = data
    },
    async getBanners() {
      const { data } = await this.$api.getBanner({
        position: isPc ? 'kfzhj_pc' : 'kfzhj_mobile'
      })

      this.banner = data

      // 控制只有一张图片的时候不自动轮播
      // this.swiperOption.autoplay = this.banner.length != 1 ? {
      //   delay: 1500,
      //   stopOnLastSlide: false,
      //   disableOnInteraction: false
      // } : false
    },
    handleClickSwiperButton(isPrev) {
      isPrev ? this.swiper.slidePrev() : this.swiper.slideNext()
    }
  }
}
</script>

<style lang="scss" scope>
.content {
	padding-bottom: 40PX;
}
@media screen and (max-width: 800px) {
  // .swiper-wrapper {
  //   overflow: hidden;
  // }
  .content{
    padding-bottom: 80px;
  }
}
</style>
<style lang="scss" scoped>

.production {
  background-color: #000;
  .content-tit{
    font-size: 20PX;
  }
  .production-list {
    // justify-content: space-between;
  }

  .production-item {
    cursor: pointer;
    text-align: center;
    width: 375PX;
    height: 380PX;
		margin-left: 37.5PX;

		&:nth-child(3n + 1) {
			margin-left: 0;
		}

    img {
      width: 100%;
      height: 265PX;
    }
  }

  // 白色主题
  &.white {
    background-color: #fff;

    .content-recommend {
      background-color: #f0f0f0;
    }
    .content-item {
      background-image: none;
    }
    .content-tit,
    .list-more {
      color: #393B3D;;
    }
    .production-slide .production-item .production-info {
      background-color: #00b06f;
    }
  }
}
.production-slide {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

}

@media screen and (max-width: 800px) {
  .swiper-container {
    // padding: 0 40px;
    width: 90%;
    box-sizing: border-box;
  }

  .production {
		.production-list {
			justify-content: space-between;
		}
		.content-tit{
			font-size: 32px;
		}
    .production-list {
      padding: 0 90px;
    }
    .production-item {
      width: 47.5%;
      height: 270px;
      margin-bottom: 40px;
			margin-left: 0;

      img {
        height: 176px;
      }

      .production-info {
        top: 65%;
        .production-tit {
        font-size: 24px;
        padding: 40px 20px;
        }
      }
    }
  }
  .list-more {
    font-size: 28px;
  }

}
</style>
